import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
    // backgroundColor: theme.palette.secondary.type,
    // backgroundColor: theme.palette.secondary.dark,
    // backgroundColor: theme.palette.secondary.light,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },

  typography: {
    padding: theme.spacing(2),
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  seeMore: {
    marginTop: theme.spacing(3),
  },
  tablePagination: {
    color: theme.palette.text.secondary,
  },
  tablePaginationCaption: {
    color: theme.palette.text.secondary,
  },
  tablePaginationSelectIcon: {
    color: theme.palette.text.secondary,
  },
  tablePaginationSelect: {
    color: theme.palette.text.secondary,
  },
  tablePaginationActions: {
    color: theme.palette.text.secondary,
  },
}));
